import { Navigate, useLocation } from 'react-router-dom';
import { soloFicha } from '@/lib/fichajes';

/**
 * Quien solo ficha (trabajador, representante) y escribe a mano otra dirección
 * privada vuelve a /fichar.
 *
 * No protege datos: eso lo hace el backend (fichajes_candado.py), que le da
 * 403 en todo lo demás. Esto evita que vea la carcasa vacía de otra pantalla,
 * con el menú entero, y piense que algo se ha roto. Las páginas públicas
 * (landings, portal de cliente, login) siguen abiertas.
 */
const SUYAS = ['/fichar', '/mis-registros', '/cambiar-password'];
const PUBLICAS = ['/', '/login', '/registro'];
const PREFIJOS_PUBLICOS = ['/landing-', '/portal-cliente', '/super-admin'];

export function GuardiaFichaje({ user }) {
  const { pathname } = useLocation();
  if (!soloFicha(user)) return null;

  const suyas = user.role === 'labor_rep' ? [...SUYAS, '/equipo-fichajes'] : SUYAS;
  if (suyas.includes(pathname) || PUBLICAS.includes(pathname)
      || PREFIJOS_PUBLICOS.some((p) => pathname.startsWith(p))) {
    return null;
  }
  return <Navigate to="/fichar" replace />;
}
